import styled from 'styled-components';

import { basicCaptionTextStyle, StyledFlex } from '@dreryk/react-components';

export const StyledAcknowledgedByCellMoreTooltip = styled(StyledFlex)`
   border-radius: 16px;
   height: 16px;
   padding: 0 4px;
   background-color: ${({ theme }) => theme.primary};
   cursor: pointer;
`;
StyledAcknowledgedByCellMoreTooltip.displayName = 'StyledAcknowledgedByCellMoreTooltip';

export const StyledAcknowledgedByCellMoreTooltipLabel = styled.span`
   ${basicCaptionTextStyle};
   color: white;
`;
StyledAcknowledgedByCellMoreTooltipLabel.displayName = 'StyledAcknowledgedByCellMoreTooltipLabel';
